import { render, staticRenderFns } from "./MessageBoxV2026.vue?vue&type=template&id=6ec9c692&scoped=true"
import script from "./MessageBoxV2026.vue?vue&type=script&lang=js"
export * from "./MessageBoxV2026.vue?vue&type=script&lang=js"
import style0 from "./MessageBoxV2026.vue?vue&type=style&index=0&id=6ec9c692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9c692",
  null
  
)

export default component.exports